/* eslint-disable */
// This is auto generated code, do not edit directly
// @ts-ignore
import * as Types from '../../../graphql/generated/types';

import { gql } from '@apollo/client';
import { BadRequestFragmentDoc } from '../../../fragments/core.hook';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type PostDcrMutationVariables = Types.Exact<{
	payload: Types.DcrCreateInput;
}>;

export type PostDcrMutation = {
	__typename?: 'Mutation';
	postDcr:
		| { __typename?: 'BadRequest'; message: string; errors: Array<string> }
		| {
				__typename?: 'DCR';
				id: any;
				networkId?: string | null;
				entityType: Types.DcrEntityType;
				entityData: string;
				note?: string | null;
				status: Types.DcrStatus;
				createdAt?: any | null;
				updatedAt?: any | null;
		  }
		| { __typename?: 'Forbidden' };
};

export const PostDcrDocument = gql`
	mutation PostDCR($payload: DCRCreateInput!) {
		postDcr(payload: $payload) {
			...BadRequest
			... on DCR {
				id
				networkId
				entityType
				entityData
				note
				status
				createdAt
				updatedAt
			}
		}
	}
	${BadRequestFragmentDoc}
`;
export type PostDcrMutationFn = Apollo.MutationFunction<
	PostDcrMutation,
	PostDcrMutationVariables
>;

/**
 * __usePostDcrMutation__
 *
 * To run a mutation, you first call `usePostDcrMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePostDcrMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [postDcrMutation, { data, loading, error }] = usePostDcrMutation({
 *   variables: {
 *      payload: // value for 'payload'
 *   },
 * });
 */
export function usePostDcrMutation(
	baseOptions?: Apollo.MutationHookOptions<
		PostDcrMutation,
		PostDcrMutationVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useMutation<PostDcrMutation, PostDcrMutationVariables>(
		PostDcrDocument,
		options
	);
}
export type PostDcrMutationHookResult = ReturnType<typeof usePostDcrMutation>;
export type PostDcrMutationResult = Apollo.MutationResult<PostDcrMutation>;
export type PostDcrMutationOptions = Apollo.BaseMutationOptions<
	PostDcrMutation,
	PostDcrMutationVariables
>;
